import axios from 'axios';
import LoginService from '../services/LoginService.js'

export default class UserService {

  getUser(user_id) {
    return axios({
      method: 'get',
      url: process.env.VUE_APP_BASE_URL + "/user/api/v1/user/" + user_id,
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("token")
      }
    })
    .then(res => res)
    .catch(error => {
      console.log(error.response)
      if (error.response.status == 401) {
        let loginService = new LoginService();
        loginService.logout()
      }
      else
        return error.response
    });
  }

  listUsers(filters) {
    return axios({
      method: 'post',
      url: process.env.VUE_APP_BASE_URL + "/user/api/v1/users",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("token")
      },
      data: filters
    })
    .then(res => res)
    .catch(error => {
      console.log(error.response)
      if (error.response.status == 401) {
        let loginService = new LoginService();
        loginService.logout()
      }
      else
        return error.response
    });
  }

  deleteUsers(ids) {
    return axios({
      method: 'post',
      url: process.env.VUE_APP_BASE_URL + "/user/api/v1/delete_users",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("token")
      },
      data: {
        ids: ids
      }
    })
    .then(res => res)
    .catch(error => {
      console.log(error.response)
      if (error.response.status == 401) {
        let loginService = new LoginService();
        loginService.logout()
      }
      else
        return error.response
    });
  }

  setUser(data) {
    return axios({
      method: 'post',
      url: process.env.VUE_APP_BASE_URL + "/user/api/v1/set_user",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("token")
      },
      data: {
        user: data
      }
    })
    .then(res => res)
    .catch(error => {
      console.log(error.response)
      if (error.response.status == 401) {
        let loginService = new LoginService();
        loginService.logout()
      }
      else
        return error.response
    });
  }

  setUserRole(user_id, roles) {
    return axios({
      method: 'post',
      url: process.env.VUE_APP_BASE_URL + "/user/api/v1/roles",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("token")
      },
      data: {
        user_id: user_id,
        roles: roles
      }
    })
    .then(res => res)
    .catch(error => {
      console.log(error.response)
      if (error.response.status == 401) {
        let loginService = new LoginService();
        loginService.logout()
      }
      else
        return error.response
    });
  }

  resetPassword(user_id, pass, confirm_pass) {
    return axios({
      method: 'post',
      url: process.env.VUE_APP_BASE_URL + "/user/api/v1/password",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("token")
      },
      data: {
        user_id: user_id,
        password: pass,
        confirm_password: confirm_pass
      }
    })
    .then(res => res)
    .catch(error => {
      console.log(error.response)
      if (error.response.status == 401) {
        let loginService = new LoginService();
        loginService.logout()
      }
      else
        return error.response
    });
  }

  getUserAccesses(user_id) {
    return axios({
      method: 'post',
      url: process.env.VUE_APP_BASE_URL + "/user/api/v1/accesses",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("token")
      },
      data: {
        user_id: user_id
      }
    })
    .then(res => res)
    .catch(error => {
      console.log(error.response)
      if (error.response.status == 401) {
        let loginService = new LoginService();
        loginService.logout()
      }
      else
        return error.response
    });
  }

  hasAccess(user_access, allowed) {
    if (!allowed)
      return true;
      
    return user_access.filter(access => allowed.includes(access)).length > 0
  }

}
